// extracted by mini-css-extract-plugin
export var title = "ImageAndText-module--title--HE4uL";
export var paragraphs = "ImageAndText-module--paragraphs--1TkZo";